@if (options) { @if (isToggle) {
<mat-button-toggle-group
  class="toggle-tabs segmented-select"
  [value]="value"
  [disabled]="disabled"
  (change)="onToggleChange($event)"
>
  @for (option of options; track option.value) {
  <mat-button-toggle
    class="segmented-select__toggle"
    [class.segmented-select__toggle--locked]="isLocked(option)"
    [value]="option.value"
  >
    <span class="segmented-select__label">{{
      option.shortLabelKey || option.labelKey | translate
    }}</span>
    @if (isLocked(option)) {
    <firebird-web-icon
      class="segmented-select__lock"
      name="lock"
      width="12px"
      height="12px"
    ></firebird-web-icon>
    }
  </mat-button-toggle>
  }
</mat-button-toggle-group>
} @else {
<firebird-web-dropdown
  type="variation-five"
  labelKey="label"
  [ngClass]="dropdownClass"
  [width]="dropdownWidth"
  [options]="options"
  [value]="value"
  [disabled]="disabled"
  (changeEvent)="onDropdownChange($event)"
></firebird-web-dropdown>
} }
